export const LOCAL_STORAGE_PREFIX = 'protocols.'

export const SEARCH_FILTER_ATTRIBUTE = 'filter[search]'
export const DATE_FILTER_ATTRIBUTE = 'filter[date]'
export const ATTENDEE_FILTER_ATTRIBUTE = 'filter[attendee]'
export const AUTHOR_FILTER_ATTRIBUTE = 'filter[author]'
export const SPACE_FILTER_ATTRIBUTE = 'filter[space]'
/** The space filter's parameter until the team → space rename (#162); still read, never written. */
export const LEGACY_SPACE_FILTER_ATTRIBUTE = 'filter[team]'
export const PUBLISHED_FILTER_ATTRIBUTE = 'filter[published]'
export const TYPE_FILTER_ATTRIBUTE = 'filter[type]'
